import type { FC } from "react";

import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import { useTopPaidLandingPages } from "./hooks/useTopPaidLandingPages";

const TopPaidLandingPages: FC = () => {
    const { switcherConfig, tableProps, footerButtonsConfig } = useTopPaidLandingPages();

    return (
        <div data-automation="TopPaidLandingPages">
            <GenericWidgetTable
                title={"website.analysis.search.overview.top.paid.landing.pages.title"}
                tooltip={"website.analysis.search.overview.top.paid.landing.pages.tooltip"}
                footerButtonsConfig={footerButtonsConfig}
                switcherConfig={switcherConfig}
                tableProps={tableProps}
                contentHeight={220}
                minHeight={376}
            />
        </div>
    );
};

export default TopPaidLandingPages;
